export default __webpack_public_path__ + "static/google-4d7175cd4fe7f5368fe466de0e4683de.png";